<template>
    <div id="iframe-box">
        <h4>{{message}}</h4>
        <p>{{add_message}}</p>
        <iframe v-if="url" :src="url"></iframe>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "MonetaIframe",
        props: {
            docsetID: { required: true, type: String }
        },
        data(){
            return {
                url: ""
            }
        },
        created() {
            if (!this.user.id && this.user.hasCredentials) {
                this.$router.push({
                    name: "webList",
                    params: this.$route.params
                });
                return;
            }
            if (!this.user.id && !this.user.hasCredentials) {
                this.$router.push({
                    name: "checkPinCode",
                    params: this.$route.params
                });
                return
            }
            this.$http.post("/moneta-iframe/", {
                clientID: this.user.id
            }).then(response => {

              // eslint-disable-next-line no-console
                console.log(response)

                if (response.data.result !== 0) {
                    // eslint-disable-next-line no-console
                    console.log(`Error: ${response.data.result.toString()}`);
                    this.$router.push({
                      name: "errorView",
                      params: {
                        status: 500,
                        message: "Возникла проблема с обработкой операции"
                    }})
                    // return;
                } else {
                  this.url = response.data.paymentURL
                }

            }).catch(error => {
                this.$router.push({
                    name: "errorView",
                    params: {
                      status: error.response.status,
                      message: error.response.error.message
                    }
                })
            });
        },
        computed: {
            ...mapGetters(["add_message", "message", "user"]),
        }
    };
</script>

<style scoped>
    #iframe-box {
        width: 100%;
        height: 100%;
        min-height: 600px;
    }

    #iframe-box iframe {
        width: 100%;
        height: 100%;
        min-height: 600px;
    }
</style>